import { createRequestType } from "../../helpers/requestType";

export const attachPaymentMethodActionType = createRequestType('ATTACH_PAYMENT_METHOD');
interface attachPaymentMethodAction {
  type: typeof attachPaymentMethodActionType.request;
  payload: string;
}

export type CustomerActionTypes =  attachPaymentMethodAction 